export const RESTRICTIONS = [
  { value: "celiaco", label: "Celíaco", short: "Sem glúten", emoji: "🌾", bg: "#FCE9D2", text: "#A35C14", pin: "#E87C55" },
  { value: "sem_lactose", label: "Sem Lactose", short: "Sem lactose", emoji: "🥛", bg: "#DDF2F4", text: "#247C87", pin: "#247C87" },
  { value: "vegano", label: "Vegano", short: "Vegano", emoji: "🌱", bg: "#E1F2E3", text: "#276832", pin: "#276832" },
];

export const RESTRICTION_MAP = Object.fromEntries(RESTRICTIONS.map((r) => [r.value, r]));

export const BRAZIL_STATES = [
  "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"
];
